function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function TerraceIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M585.008 963.967h-43.008v-236.352h-60v236.352h-43.008c-16.563 0-30 13.438-30 30 0 16.57 13.438 30 30 30h146.016c16.57 0 30-13.43 30-30 0-16.563-13.43-30-30-30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M482 276.692h60v210.93h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.999 216.692h964.003c14.75 0 27.313-10.734 29.625-25.305s-6.32-28.664-20.359-33.227l-482.017-156.688c-6.023-1.961-12.516-1.961-18.547 0l-481.978 156.688c-14.031 4.563-22.664 18.656-20.352 33.227 2.305 14.57 14.875 25.305 29.625 25.305z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M193.507 577.622v59.992c0 16.57 13.43 30 30 30h576.986c16.57 0 30-13.43 30-30v-59.992c0-16.57-13.43-30-30-30h-576.986c-16.57 0-30 13.43-30 30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M249.593 784.037h-189.555v-176.414c0-16.57-13.438-30-30-30-16.57 0-30 13.43-30 30v386.376c0 16.57 13.43 30 30 30 16.563 0 30-13.43 30-30v-149.961h123.469v149.961c0 16.57 13.43 30 30 30 16.563 0 30-13.43 30-30v-149.961h6.086c16.563 0 30-13.43 30-30 0-16.563-13.43-30-30-30z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M993.985 577.622c-16.57 0-30 13.43-30 30v176.414h-189.555c-16.57 0-30 13.438-30 30 0 16.57 13.43 30 30 30h6.086v149.961c0 16.57 13.43 30 30 30s30-13.43 30-30v-149.961h123.469v149.961c0 16.57 13.43 30 30 30s30-13.43 30-30v-386.376c0-16.57-13.43-30-30-30z"
  })));
  return output;
}
